import { useNavigate } from "react-router-dom";
import { MakyMascot } from "@/components/brand/MakyMark";
import { Button } from "@/components/ui";

/** 없는 주소. 지금까지는 흰 화면이었다 — 오래된 주문 링크나 오타 하나로
 *  아무 안내 없이 막다른 길에 서게 된다. */
export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-4 p-6 text-center">
      <MakyMascot size={120} className="mx-auto" />
      <div>
        <h1 className="text-heading-1 font-bold text-label-normal">여긴 아무것도 없어요</h1>
        <p className="mt-2 text-body-2 text-label-alternative">
          주소가 잘못됐거나, 이미 지워진 링크예요.
        </p>
      </div>
      <div className="flex justify-center">
        <Button onClick={() => navigate("/", { replace: true })}>주문 화면으로</Button>
      </div>
    </main>
  );
}
